"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-require-imports */

var SuccessIcon = require('@tencent/ixd-icons-react/dist').SuccessIcon;
function index(props) {
  var style = props.style,
    _a = props.configuration,
    configuration = _a === void 0 ? [] : _a,
    isAcross = props.isAcross,
    tab = props.tab;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-main",
    style: tab ? {
      marginBottom: 40,
      paddingLeft: 0,
      paddingRight: 0
    } : {}
  }, isAcross ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-main-list"
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var firstTitle = item.firstTitle,
      firstDesc = item.firstDesc,
      _a = item.list,
      list = _a === void 0 ? [] : _a,
      bigNum = item.bigNum,
      smallTxt = item.smallTxt,
      thirdDesc = item.thirdDesc,
      tagTxt = item.tagTxt,
      btnTxt = item.btnTxt,
      onCallback = item.onCallback,
      extendProps = item.extendProps;
    var newList = list;
    if ((list === null || list === void 0 ? void 0 : list.length) > 4) {
      newList = list.slice(0, 4);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item",
      key: index
    }, tagTxt && ( /*#__PURE__*/_react["default"].createElement("div", {
      className: "tips-card"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "tips-card__l--img"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "tips-card__l--img-level"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'tips-card__title'
    }, tagTxt))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'tips-card__r--img'
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-first",
      style: (configuration === null || configuration === void 0 ? void 0 : configuration.length) > 4 ? {
        background: '#f2f8ff'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-first-title"
    }, firstTitle), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-first-desc"
    }, firstDesc)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-second"
    }, newList === null || newList === void 0 ? void 0 : newList.map(function (item, index) {
      var secondTitle = item.secondTitle,
        secondDesc = item.secondDesc;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-main-item-second-item",
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-main-item-second-item-title"
      }, secondTitle), /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-main-item-second-item-desc"
      }, secondDesc));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third-num"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third-num-big"
    }, bigNum), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third-num-small"
    }, smallTxt)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third-desc"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third-desc-content"
    }, thirdDesc)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-main-item-third-btn"
    }, /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: "price-set-main-item-third-btn-txt",
      onClick: function onClick() {
        onCallback === null || onCallback === void 0 ? void 0 : onCallback();
      }
    }, extendProps || {}), btnTxt))));
  }))) : (
  /*#__PURE__*/
  // 竖版
  _react["default"].createElement("div", {
    className: "price-set-vertical-main-list"
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var firstTitle = item.firstTitle,
      firstDesc = item.firstDesc,
      bigNum = item.bigNum,
      smallTxt = item.smallTxt,
      thirdDesc = item.thirdDesc,
      onCallback = item.onCallback,
      extendProps = item.extendProps,
      btnTxt = item.btnTxt,
      tagTxt = item.tagTxt,
      _a = item.descList,
      descList = _a === void 0 ? [] : _a,
      _b = item.list,
      list = _b === void 0 ? [] : _b;
    var newList = list;
    var newDescList = descList;
    if ((descList === null || descList === void 0 ? void 0 : descList.length) > 5) {
      newDescList = descList.slice(0, 5);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('price-set-vertical-main-item', {
        'three-item': (configuration === null || configuration === void 0 ? void 0 : configuration.length) % 3 === 0
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-header",
      style: (configuration === null || configuration === void 0 ? void 0 : configuration.length) > 4 ? {
        background: '#f2f8ff'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-title"
    }, firstTitle), tagTxt ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: 'special-tag'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'special-tag-txt'
    }, tagTxt))) : null), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-num"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-num-big"
    }, bigNum), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-num-small"
    }, smallTxt)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-third-desc"
    }, thirdDesc), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-third-btn"
    }, /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: "price-set-vertical-main-item-third-btn-txt",
      onClick: function onClick() {
        onCallback === null || onCallback === void 0 ? void 0 : onCallback();
      }
    }, extendProps || {}), btnTxt)), firstDesc ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-first-desc-wrap"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-first-desc"
    }, firstDesc))) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-second-item-wrap"
    }, (newList === null || newList === void 0 ? void 0 : newList.length) > 0 && (newList === null || newList === void 0 ? void 0 : newList.map(function (item, index) {
      var secondTitle = item.secondTitle,
        secondDesc = item.secondDesc;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('price-set-vertical-main-item-second-item', {
          'more-four': (newList === null || newList === void 0 ? void 0 : newList.length) > 4
        }),
        key: index
      }, (newList === null || newList === void 0 ? void 0 : newList.length) <= 4 ? ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-vertical-main-item-second-item-title"
      }, secondTitle), /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-vertical-main-item-second-item-desc"
      }, secondDesc))) : ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "item-title-more-four"
      }, secondTitle), /*#__PURE__*/_react["default"].createElement("span", {
        className: "item-desc-more-four"
      }, secondDesc))));
    }))), (newDescList === null || newDescList === void 0 ? void 0 : newDescList.length) > 0 ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-tick-desc-wrap"
    }, newDescList === null || newDescList === void 0 ? void 0 : newDescList.map(function (item, index) {
      var txt = item.txt;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-vertical-main-item-tick-icon",
        key: index
      }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, null), /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-vertical-main-item-tick-desc"
      }, txt));
    }))) : null);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-mobile-main-list"
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var firstTitle = item.firstTitle,
      firstDesc = item.firstDesc,
      bigNum = item.bigNum,
      smallTxt = item.smallTxt,
      thirdDesc = item.thirdDesc,
      onCallback = item.onCallback,
      extendProps = item.extendProps,
      btnTxt = item.btnTxt,
      tagTxt = item.tagTxt,
      _a = item.descList,
      descList = _a === void 0 ? [] : _a,
      _b = item.list,
      list = _b === void 0 ? [] : _b;
    var newList = list;
    var newDescList = descList;
    if ((descList === null || descList === void 0 ? void 0 : descList.length) > 5) {
      newDescList = descList.slice(0, 5);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('price-set-vertical-main-item', {
        'three-item': (configuration === null || configuration === void 0 ? void 0 : configuration.length) % 3 === 0
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-header",
      style: (configuration === null || configuration === void 0 ? void 0 : configuration.length) > 4 ? {
        background: '#f2f8ff'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-title"
    }, firstTitle), tagTxt ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: 'special-tag'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'special-tag-txt'
    }, tagTxt))) : null), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-num"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-num-big"
    }, bigNum), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-num-small"
    }, smallTxt)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-third-desc"
    }, thirdDesc), /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-third-btn"
    }, /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: "price-set-vertical-main-item-third-btn-txt",
      onClick: function onClick() {
        onCallback && onCallback();
      }
    }, extendProps || {}), btnTxt)), firstDesc ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-vertical-main-item-first-desc"
    }, firstDesc)) : null, /*#__PURE__*/_react["default"].createElement("div", null, newList === null || newList === void 0 ? void 0 : newList.map(function (item, index) {
      var secondTitle = item.secondTitle,
        secondDesc = item.secondDesc;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('price-set-mobile-main-item-second-item', {
          'more-four': (newList === null || newList === void 0 ? void 0 : newList.length) > 4
        }),
        key: index
      }, (newList === null || newList === void 0 ? void 0 : newList.length) <= 4 ? ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-vertical-main-item-second-item-title"
      }, secondTitle), /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-vertical-main-item-second-item-desc"
      }, secondDesc))) : ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "item-title-more-four"
      }, secondTitle), /*#__PURE__*/_react["default"].createElement("span", {
        className: "item-desc-more-four"
      }, secondDesc))));
    })), (newDescList === null || newDescList === void 0 ? void 0 : newDescList.length) > 0 ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-mobile-main-item-tick-desc-wrap"
    }, newDescList === null || newDescList === void 0 ? void 0 : newDescList.map(function (item, index) {
      var txt = item.txt;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-mobile-main-item-tick-icon",
        key: index
      }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, null), /*#__PURE__*/_react["default"].createElement("div", {
        className: "price-set-mobile-main-item-tick-desc"
      }, txt));
    }))) : null);
  })))));
}